module.exports = __webpack_public_path__ + "static/fonts/iconfont.d515d836.ttf";